"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeDatabaseBytesText = encodeDatabaseBytesText;
exports.isDatabaseBytesText = isDatabaseBytesText;
exports.decodeDatabaseBytesText = decodeDatabaseBytesText;
/**
 * Base64 text of bytes for JSON, which has no byte values: the database
 * writer wire, snapshots of row fingerprints and index document keys.
 */
const BASE64 = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
function encodeDatabaseBytesText(bytes) {
    let binary = '';
    for (let offset = 0; offset < bytes.length; offset += 0x8000)
        binary += String.fromCharCode(...bytes.subarray(offset, offset + 0x8000));
    return btoa(binary);
}
function isDatabaseBytesText(text) {
    return typeof text === 'string' && BASE64.test(text);
}
/** Bytes of {@link encodeDatabaseBytesText}; callers check the text first. */
function decodeDatabaseBytesText(text) {
    return Uint8Array.from(atob(text), char => char.charCodeAt(0));
}
